import dayjs from 'dayjs';

export const validateDateOrder = (
  startDate: string | Date,
  endDate: string | Date
): true | string => {
  if (!startDate || !endDate) {
    return true;
  }

  const start = dayjs(startDate);
  const end = dayjs(endDate);

  if (!start.isValid() || !end.isValid()) {
    return true;
  }

  return (
    start.isBefore(end) ||
    start.isSame(end) ||
    'Start Date/Time Cannot Be Greater than End Date/Time'
  );
};
